<template>
  <div class="main-area">
    <span class="main-top" >{{ getSelectedLabel }}</span>
    <label class="time-period">{{getArticleDate}}</label>
    <span class="display-large">
      <ul>
        <li>文字サイズ</li>
        <li id="smallFont" tabindex="1" v-on:click="decreaseFont" class="activeFont" v-bind:class="{ active: isActive }">
          小
        </li>
        <li id="mediumFont" tabindex="1" v-on:click="resetFont" class="activeFont" v-bind:class="{ active: isMedActive }">
          中
        </li>
        <li id="largeFont" tabindex="1" v-on:click="increaseFont" class="activeFont" v-bind:class="{ active: isBigActive }">
          大
        </li>
      </ul>
    </span>
    <el-tabs v-model="activeName"  @tab-click="handleTapClick">
      <el-tab-pane label="全媒体" name="first" class v-if="tabs.length>=2">
        <el-collapse v-model="activeNames">
          <!-- Custom collapse tab -->
          <News ref="newsRef" v-if="news_article_flag && user_group_news_article_flag"/>
          <!-- Magazine tab -->
          <Magazine ref="magazineRef" v-if="magazine_article_flag && user_group_magazine_article_flag"/>
          <!-- Element Ui collapse tab -->
          <Web ref="webRef" v-if="web_news_article_flag && user_group_web_news_article_flag"/>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane :label=getTotalNewsLabel name="second" v-if="news_article_flag && user_group_news_article_flag">
        <el-collapse v-model="activeNames">
          <!-- Custom news second tab -->
          <NewsTab ref="newsTapRef"/>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane class="alter-tab-bg" :label=getMagazineTotalLabel name="fourth" v-if="magazine_article_flag && user_group_magazine_article_flag">
        <el-collapse v-model="activeNames">
          <!-- Custom Magazine Third tab -->
          <MagazineTab ref="magazineTapRef"/>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane class="alter-tab-bg" :label=getWebTotalLabel name="third" v-if="web_news_article_flag && user_group_web_news_article_flag">
        <el-collapse v-model="activeNames">
          <!-- Custom web second tab -->
          <WebTab ref="webTapRef"/>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
 
import $ from "jquery";
import News from "./news.vue";
import Web from "./web.vue";
import NewsTab from "./newstab.vue";
import WebTab from "./webtab.vue";
import Magazine from "./magazine.vue";
import MagazineTab from "./magazineTab.vue";
import { mapGetters } from "vuex";

export default {
  name: "prime",
  props: ["fontSize","active"],
  components: {
    News,
    Web,
    Magazine,
    MagazineTab,
    NewsTab,
    WebTab
  },
  data() {
    return {
      activeName: "first",
      activeNames: ["1"],
      newsCount: '',
      form: {
        region1: "",
        region2: ""
      },
      visible: false,
      groups: {
        "group 1": {
          name: "Menu 1",
          open: "false",
          items: ["item1"]
        }
      },
      drag: false,
      options: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      dropdownoptions: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      tabs: [],
      optionValue1: "なし",
      optionValue2: "昇順",
      isActive: false,
      // 2021/10/11 #全記事一括CSV出力ボタンの挙動 START
      isMedActive: true,
      // 2021/10/11 #全記事一括CSV出力ボタンの挙動 END
      isBigActive: false,
      news_article_flag: false,
      web_news_article_flag: false,
      magazine_article_flag: false,
      user_group_news_article_flag: false,
      user_group_web_news_article_flag: false,
      user_group_magazine_article_flag: false,
    };
  },
  methods: {
    decreaseFont() {
      this.$LogButtonEvent("mainComponent","SmallFont");
      this.$LogMethodIN("mainComponent","decreaseFont");
      $(".article-img img").css({
        "width": "calc(80% * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $('.articleLabel').css({
        "width": "65px",
      });
      $('.select_custom').css({"width": "64px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '30px');
      $('.strip').addClass('smallStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('largeStrip');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '28px');
      $('.toolTipDiv span label').css('line-height', '30px');
      $('.year-arrow').css('line-height', '30px');
      $('.year-arrow').addClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 0.8)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 0.8)"); 
      $(".selectList").css("font-size", "calc(8pt * 0.8)"); 
      $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 0.8)",
        "height": "calc(14px * 0.8)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 0.8)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('smallCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").removeClass('largeCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      //$(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 0.8)");
      $(".newsTitle, .webNewsTitle, .magazineNewsTitle").css("font-size","calc(9.6pt * 0.8)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "6.4pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "8.32pt");
      $(".article-list ul li").css("font-size", "6.4pt");
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      var font_size = 0
      this.$store.commit("situation0001/setDefaultFontSize",font_size)
      this.$LogMethodOut("mainComponent","decreaseFont");
    },
    resetFont() {
      this.$LogButtonEvent("mainComponent","CurrentFont");
      this.$LogMethodIN("mainComponent","resetFont");
      $(".article-img img").css({
        "width": "80%",
        "height": "22px",
      });
      $('.articleLabel').css({
        "width": "65px",
      });
      $('.select_custom').css({"width": "76px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '32px');
       $('.strip').removeClass('smallStrip');
       $('.strip').removeClass('largeStrip');
       $('.strip').addClass('mediumStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '34px');
      $('.toolTipDiv span label').css('line-height', '36px');
      $('.year-arrow').css('line-height', '36px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', '8pt');
      $(".toolTipDiv span label").css("font-size", "8pt");
      $(".selectList").css("font-size", "8pt");
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "14px",
        "height": "14px",
      });
      $(".display-size > ul > li > span").css('font-size', '9.6pt');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "22px",
        "height": "22px",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
       "width": "22px",
        "height": "22px",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "22px",
        "height": "22px",
      });
      $(".ico_batch-display_up").css({
        "width": "16.57px",
        "height": "22px",
      });
      $(".ico_another-tab_up").css({
        "width": "22px",
        "height": "22px",
      });
      // $(".newsTitle, .webNewsTitle").css("font-size", "9.6pt");
      $(".newsTitle, .webNewsTitle, .magazineNewsTitle").css("font-size", "9.6pt");
      $(".display-size, .menuLable div, .message-text, .DisplaySize").css("font-size", "8pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "10.4pt");
      $(".article-list ul li").css("font-size", "8pt");
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      var font_size = 1
      this.$store.commit("situation0001/setDefaultFontSize",font_size)
      this.$LogMethodOut("mainComponent","resetFont");
    },
    increaseFont() {
      this.$LogButtonEvent("mainComponent","BigFont");
      this.$LogMethodIN("mainComponent","increaseFont");
      $(".article-img img").css({
        "width": "calc(80% * 1.5)",
        "height": "calc(22px * 1.5)",
      }); 
      $('.articleLabel').css({
        "width": "85px",
        "display": "inline-table"
      });
      $('.select_custom').css({"width": "108px"});
      $('.ariticle-bottom ul').css('margin-left', '67px');
      $('.commentRow ul').css('margin-left', '85px');
      $('.commentRow .logoArtInfo').css('min-height', '38px');
      $('.strip').addClass('largeStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('smallStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').addClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '45px');
      $('.menuParent, .webMenuParent').css('height', '46px');
      $('.toolTipDiv span label').css('line-height', '47px');
      $('.year-arrow').css('line-height', '54px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 1.5)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 1.5)"); 
      $(".selectList").css("font-size", "calc(8pt * 1.5)"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 1.5)",
        "height": "calc(14px * 1.5)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 1.5)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
       // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      // $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 1.5)");
      $(".newsTitle, .webNewsTitle, .magazineNewsTitle").css("font-size","calc(9.6pt * 1.5)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "12pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "15.6pt");
      $(".article-list ul li").css("font-size", "12pt");
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      var font_size
      this.$store.commit("situation0001/setDefaultFontSize",font_size)
       this.$LogMethodOut("mainComponent","increaseFont");
    },
    
    clear() {
      (this.optionValue1 = ""), (this.optionValue2 = "");
    },
    handleTapClick(obj) {
      this.$LogButtonEvent("mainComponent","TapClick");
      this.$LogMethodIN("mainComponent","handleTapClick");
      if(obj.name == "third"){
        this.$refs.webTapRef.TapClickedInParent();
      }else if(obj.name == "second"){
        this.$refs.newsTapRef.TapClickedInParent();
      }else{
        this.$refs.newsRef.TapClickedInParent();
        this.$refs.webRef.TapClickedInParent();
      }
      this.$LogMethodOut("mainComponent","handleTapClick");
    },
  },
  computed: {
    ...mapGetters("situation",["getArticleDate", 
                              "getTotalNewsCount", 
                              "getSelectedLabel", 
                              "getTotalNewsLabel", 
                              "getWebTotalLabel",
                              "getMagazineTotalLabel"]),
    ...mapGetters("situation0001", ["getNews_Article_Flag",
                                    "getDefault_Font_Size",
                                    "getWeb_News_Article_Flag",
                                    "getMagazine_Article_Flag",
                                    "getUserGroup_News_Article_Flag",
                                    "getUserGroup_Web_News_Article_Flag",
                                    "getUserGroup_Magazine_Article_Flag"])
  },
  mounted(){
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
    }
    else if(font_size_flag == 1)
    {
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
    }
    else
    {
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
    }

    //get the news_article_flag from the session
    this.news_article_flag = this.getNews_Article_Flag;
    //get the web_news_article_flag from the session
    this.web_news_article_flag = this.getWeb_News_Article_Flag;
    //get the magazine_article_flag from the session
    this.magazine_article_flag = this.getMagazine_Article_Flag;

    //get the user_group_news_article_flag from the session
    this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag;
    //get the user_group_web_news_article_flag from the session
    this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag;
    //get the user_group_magazine_article_flag from the session
    this.user_group_magazine_article_flag = this.getUserGroup_Magazine_Article_Flag;
    if(this.news_article_flag && this.user_group_news_article_flag)
    {
      this.tabs.push('news');
    }
    if(this.magazine_article_flag && this.user_group_magazine_article_flag)
    {
      this.tabs.push('magazine');
    }
    if(this.web_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.tabs.push('web');
    }

    if(this.tabs.length>=2)
    {
      this.activeName = "first";
    }
    else if(this.news_article_flag && this.user_group_news_article_flag)
    {
      this.activeName = "second";
    }
    else if(this.magazine_article_flag && this.user_group_magazine_article_flag)
    {
      this.activeName = "fourth";
    }
    else if(this.web_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.activeName = "third";
    }

    
  },
  created() {
    //For the screen Title
    document.title = "記事閲覧";
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
        this.$router.push('sp');
    }
    else{
        this.$router.push('/0002');
    }

  },
   
  beforeCreate(){
    // 2023/03/30  #14188  START
    //this.$store.dispatch('communication/resetAllArticleValues');
    //this.$store.commit('situation/setthemetopics', []);
    //this.$store.commit('situation/settheme', []);
    //this.$store.commit('situation/setthemegrouptopics', []);
    //this.$store.commit('situation/setTodayArticleLabel','');
    if(this.$session.get('triggerSearchFunctionFlag') != 1 && this.$session.get('triggerSearchFunctionFlag') != 2){
      this.$store.dispatch('communication/resetAllArticleValues');
      this.$store.commit('situation/setthemetopics', []);
      this.$store.commit('situation/settheme', []);
      this.$store.commit('situation/setthemegrouptopics', []);
      this.$store.commit('situation/setTodayArticleLabel','');
    }
    // 2023/03/30  #14188  END
  }
};
</script>

<style scoped>
@import "../../assets/css/style.css";
.el-tooltip__popper[x-placement^="bottom"] {
  margin-top: 8px !important;
}

.collapse-header-second {
  margin-top: 1px;
}
.main-area {
  text-align: left;
  position: relative;
  margin-right: 11px;
  width: 100%;
}

.display-large ul {
  padding: 0px;
  margin: 0px;
  position: absolute;
  right: 0px;
  z-index: 1010;
  margin-top: 25px;
  height: 20px;
}

.list-csv {
  border-right: 1px solid #ccc;
  font-size: 10pt;
  line-height: 25px;
}

.list-csv span {
  padding-right: 8px;
}

.small-button {
  padding: 0px 11px !important;
  height: 17px;
  margin-top: 10px;
  font-size: 8pt;
}

.small-button span {
  font-size: 7pt;
  vertical-align: middle;
}

.display-large ul li {
  cursor: pointer;
  list-style: none;
  padding-right: 8px;
  float: left;
  color: var(--grayDark);
}

.CustomTabs {
  color: #ffffff !important;
  background: #0097e0 !important;
  font-weight: bold !important;
  font-size: 12pt !important;
  border-radius: 4px 4px 0px 0px !important;
}

.main-top {
  font-size: 9.6pt;
  font-weight: bold;
  text-align: left;
  color: var(--primary);
  margin-left: 16px;
  margin-top: 0px;
  display: inline-block;
  margin-bottom: -5px;
}

.el-select input {
  height: 30px !important;
}

.el-collapse-item__arrow {
  font-weight: 600 !important;
  color: #0097e0 !important;
  font-size: 18px !important;
}

.collapse-head-one {
  background: #242950;
  width: 130px;
  text-align: center;
  color: #fff;
  font-weight: 600;
}

.collapse-head-two {
  background: #242950;
  width: 130px;
  text-align: center;
  color: #fff;
  font-weight: 600;
}

.collapse-list ul {
  padding: 0px;
  margin: 0px;
}

.collapse-list ul li {
  list-style: none;
  float: left;
  padding: 0px 0px 0px 7px;
  font-size: 10pt;
  line-height: 25px;
}

.collapse-list ul li img {
  width: 14px;
  vertical-align: middle;
}

.display-size ul {
  padding: 0px 0px;
  margin: 0px;
}

.display-size ul li {
  color: #ccc;
  list-style: none;
  text-align: left;
  padding: 5px 30px;
  cursor: pointer;
}

.display-size ul li span:hover {
  background: #e0f2fb;
}

.div-popover {
  color: #f00;
}
.el-tabs__item {
  min-width: 130px !important;
}

.el-tabs__item.is-active:nth-last-child(1) {
  background: #242950;
}

.el-tabs__item.is-active:nth-last-child(2) {
  background: #242950;
  color: var(--grayLight) !important;
}

.el-tabs__item.is-active:nth-last-child(3) {
  background: #0097e0;
  color: var(--grayLight) !important;
}

.el-tabs__item:hover {
  color: #ccc !important;
}

.time-period {
  font-size: 8pt;
  font-weight: bold;
  color: var(--grayDark);
  margin-left: 8px !important;
  padding-left: 0px;
}

.togglepane li {
  color: var(--grayDark) !important;
}

.button-plain:nth-child(2) {
  margin-left: 30px !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #e0f2fb !important;
}

.el-scrollbar__wrap {
  overflow: hidden !important;
}

.display-large ul li:nth-child(1) {
  font-size: 8pt;
  color: var(--grayDark);
  margin-top: 0px;
}

.display-large ul li:nth-child(2) {
  font-size: 7.2pt;
  color: var(--grayDark);
  margin-top: 2px;
}

.display-large ul li:nth-child(3) {
  font-size: 8.8pt;
  margin-top: 0px;
}

.display-large ul li:nth-child(4) {
  font-size: 9.6pt;
  padding-right: 0px;
  color: var(--grayDark);
  margin-top: -1px;
}
#smallFont:focus {
  outline: none;
  color: var(--secondary);
}
#mediumFont:focus {
  outline: none;
  color: var(--secondary);
}
#largeFont:focus {
  outline: none;
  color: var(--secondary);
}
.active {
  color: var(--secondary) !important;
}

.el-tabs__item {
    margin-right: 1px;
    background: var(--inActiveTab) !important;
    border-radius: 4px 4px 0px 0px;
    width: 188.86px !important;
}


</style>
